/**
 * Shared dependencies
 */
import type { StoreFunctions } from '../../shared/types/store';
import type { List } from '../../shared/types/lists';

/**
 * Internal dependencies
 */
import { createUserList, type CreateUserListParams } from '../requests';

/**
 * Creates a new list for the current user and updates the store.
 * Also dispatches a ListEvent to notify other parts of the app.
 *
 * @param fn - Function to update the store state.
 * @param params - The parameters for creating the list.
 * @return Promise that resolves to the created user's list.
 */
export async function listsCreate(fn: StoreFunctions, params: CreateUserListParams): Promise<List> {
	const {
		events: { ListEvent },
	} = window.valioApp;

	// Create the user list based on params
	const list = await createUserList(params);

	const listsRecord = { [list.id]: { ...list, items: [] } };

	// Update the store with the new list
	fn.set((state) => ({
		data: {
			lists: {
				...state.data.lists,
				...listsRecord,
			},
		},
	}));

	// Dispatch the event to notify other parts of the app
	ListEvent.create({ data: listsRecord });

	// Return the created list
	return list;
}
